/**
 * When an organisation is locked for non-payment the server only lets the admin reach billing,
 * support and their own profile. Everything else answers 403 `BILLING_ONLY`, so the app keeps
 * the admin on these screens instead of showing pages that cannot load.
 */
const BILLING_ONLY_PATHS = ["/subscription", "/billing", "/support", "/profile"];

export function isBillingOnlyPath(pathname: string): boolean {
    return BILLING_ONLY_PATHS.some((p) => pathname === p || pathname.startsWith(`${p}/`));
}
